module.exports = __webpack_public_path__ + "static/media/DejaVuSansMono.8b401df4.png";